module.exports = __webpack_public_path__ + "img/water_level_bottom.191b5021.svg";